import React, {useState} from 'react';
import {Grid} from "@mui/material";
import {SETable} from "../../../../components/SETable";
import {RiFilterOffLine} from "react-icons/ri";
import {SEText} from "../../../../components/SEText";
import {SEButtonExport} from "../../../../components/SEButtonExport";
import useFilterHandler from "../../../../hooks/useFilterHandler";
import {onlyNumbers, removeEmpty, removeEmptyProperties} from "../../../../utils/utils";
import moment from "moment/moment";
import {formatDateToBR} from "../../../../../utils/time";
import useExcelExport from "../../../../hooks/useExcelExport";
import {useQuery} from "react-query";
import {tableColumns} from "./tableColumns";
import {AtendimentoRecusadoService} from "../services";
import useFormMutation from "../../hooks/useFormMutation";
import {BaSeDialogContext} from "@base/react";
import {handleModalAdmin} from "../../../../../utils/handleModalAdmin";
import {SEButton} from "../../../../components/SEButton";
import {cnpjMask} from "../../../../../utils/mask";
import SEInputSearch from "../../../../components/SEInputSearch";

const Tabela = () => {

    const [searchText, setSearchText] = useState<any>(null);

    const {
        paginationFilters,
        bodyFilters,
        handleResetBodyFilters,
        handleLinesPerPage,
        handleChangeOrder,
        handlePageChange,
        handleSearchChange,
    } = useFilterHandler();

    const {showModal} = React.useContext(BaSeDialogContext);


    const handleCleanFilters = () => {
        handleResetBodyFilters()
        setSearchText(null)
    }

    const {
        data,
        isLoading,
        refetch,
    } = useQuery({
        queryFn: () => AtendimentoRecusadoService.findAll(paginationFilters, removeEmpty(bodyFilters)),
        queryKey: ["atendimentoRecusadoData", paginationFilters, bodyFilters],
    });


    const {deleteMutation} = useFormMutation({
        showModal,
        service: AtendimentoRecusadoService
    });


    const handleDelete = async (id: any) => {
        handleModalAdmin({
            title: `Excluir Registro`,
            content: `Você tem certeza que deseja excluir esse registro?`,
            msgOnSuccess: `Registro excluído com sucesso`,
            onFinish: () => {
                refetch()
            },
            onConfirmClick: () => deleteMutation(id),
            onCancelClick: () => console.log('modal closed...'),
            showModal: showModal,
            showAPIErrorIfAvailable: true
        });
    };


    const fetchDataExcel = async () => {
        const bodyParams = removeEmptyProperties(bodyFilters);
        const pageFilter = {...paginationFilters, page: 0, linesPerPage: 1000};
        const response = await AtendimentoRecusadoService.findAll(pageFilter, bodyParams);
        return response?.content?.map((data: any) => ({
            COD: data.id,
            UF: data.atendente?.uf?.sigla,
            AGENTE: data.atendente?.nome,
            CNPJ: cnpjMask(data.cnpj),
            DATA: data?.dataCriacao ? moment(data?.dataCriacao).format('DD/MM/YYYY') : '',
        }));
    };

    const {executeDownload, downloading} = useExcelExport({
        handleDataCallback: fetchDataExcel,
        filename: `Exportacao_Atendimentos_Recusados_${formatDateToBR(new Date())}`,
        colorLoading: '#3498db',
        isCsv: true,
    });

    return (
        <Grid item>
            <Grid container>
                <Grid item xs={12}>
                    <SETable
                        pagination={true}
                        headerTableColor={"#7B80FF"}
                        tableColor={"#FFFFFF"}
                        totalElements={data?.totalElements}
                        totalPages={data?.totalPages}
                        linesPerPageFilters={paginationFilters?.linesPerPage}
                        isLoading={isLoading}
                        data={data?.content ?? []}
                        page={paginationFilters?.page}
                        columns={tableColumns({handleDelete})}
                        orderBy={paginationFilters?.orderBy}
                        direction={paginationFilters?.direction}
                        onOrderChange={handleChangeOrder}
                        onPagePreviousChange={handlePageChange}
                        onPageNextChange={handlePageChange}
                        onLinesPerPageChange={handleLinesPerPage}
                        tableHeader={
                            <>
                                <Grid container justifyContent="space-between" alignItems="center" spacing={2} mb={2}>
                                    <Grid item md={3}>
                                        <SEInputSearch
                                            value={searchText}
                                            onClick={() => handleSearchChange(onlyNumbers(searchText))}
                                            onChange={(e) => setSearchText(e?.target?.value)} />
                                    </Grid>


                                    <Grid item>
                                        <SEButtonExport isLoading={downloading} onClick={executeDownload}/>
                                    </Grid>
                                </Grid>

                                <Grid container justifyContent="space-between" alignItems="center" mb={2}
                                      sx={{padding: '7px'}}>
                                    <Grid item>
                                        <div
                                            style={{
                                                display: "flex",
                                                marginTop: "16px",
                                                alignItems: "center",
                                            }}
                                        >
                                            {!!data?.totalElements && (
                                                <SEText as="p" font="Mulish">
                                                    <strong>{data?.totalElements}</strong>{" "}
                                                    {data?.totalElements === 1
                                                        ? "resultado encontrado"
                                                        : "resultados encontrados"}
                                                </SEText>
                                            )}
                                        </div>
                                    </Grid>

                                    <Grid item>
                                        <div
                                            style={{
                                                display: "flex",
                                                marginTop: "16px",
                                                alignItems: "center",
                                            }}
                                        >
                                            <SEButton onClick={handleCleanFilters}>
                                                <RiFilterOffLine size={20}/> Limpar Filtros
                                            </SEButton>
                                        </div>
                                    </Grid>
                                </Grid>
                            </>
                        }
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Tabela;